import { EntityInfoActions } from 'src/store/actions/entityInfoActions';
const initialState = {
    loading: false,
    showEntityInspector: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case EntityInfoActions.SET_SHOW_ENTITY_INSPECTOR: {
            return {
                ...state,
                showEntityInspector: payload
            };
        }
        case EntityInfoActions.SET_ENTITY_INFO_LOADING: {
            return {
                ...state,
                loading: payload
            };
        }
        default: {
            return state;
        }
    }
};
